import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { RefObject } from 'react';

export const DeepLinkHandler: LoadableType<{
	scrollTargetId: string | null;
	refOfNodeToWatchForChange: RefObject<Element>;
	scrollTarget?: string;
}> = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-DeepLinkHandler" */ './DeepLinkHandler.tsx'))
			.DeepLinkHandler,
});
